export const channelTypeFromCID = cid => {
  let type = 'internal';

  if (cid.indexOf('-requestannouncements-') > -1) type = 'announcements';
  if (cid.indexOf('-adhoc-') > -1) type = 'adhoc';
  if (cid.indexOf('-vgroup-') > -1 || cid.indexOf('-vendororg-') > -1) type = 'vendor';

  return type;
};

const idPositions = {
  adhoc: 2, // not a request id, but a UUID
  announcements: 2,
  internal: 1,
  vendor: 0
};

// This method depends on specific naming in GetStream channel setup
export const doesChannelIdMatchRequest = (cid, request) => {
  if (!request || !request.id) return false;

  const cidArr = cid.split('-');
  const type = channelTypeFromCID(cid);
  const idPosition = idPositions[type];

  return cidArr[idPosition] === request.id.toString();
};

// This method depends on specific naming in GetStream channel setup
export const requestIdFromChannelId = cid => {
  const cidArr = cid.split('-');
  const type = channelTypeFromCID(cid);
  if (type === 'adhoc') {
    return null;
  }

  return cidArr[idPositions[type]];
};

/**
 * Asynchronous get call using complete message list
 * @param channel {Object} StreamChat channel to query with
 * @returns {Promise<*>} Promise which will contain the un-watched channel object
 */
export async function getCompleteListOfChannelMessages (channel) {
  const data = {};
  const messages = {
    limit: 10000, // Required to be greater than 0, figure 10k magic number if probably fine
    state: false
  };

  return channel.query({ data, messages });
}

/**
 * Simple async wrapper for querying with just filter
 * @param client {Object} GetStream client object with connection info embedded
 * @param filter {{}} Plain object of the form { field: {query}|value }, ie { id: { $in: [ids] }}, or { adHoc: true }
 * @returns {Promise<Channel[]>} List of channels matching
 */
export async function getChannels (client, filter) {
  return client.queryChannels(filter, {}, {});
}
